module.exports = __webpack_public_path__ + "img/54.3dfe0c80.jpg";